import './navigation'

const CAMPAIGN_BY_UTM = {
  alpha_beta_users_reconnect: 'reddit-alpha-beta-users',
  desktop_first_run_share: 'desktop-first-run-share',
  desktop_setup_help: 'desktop-setup-help',
  desktop_setup_help_resolved: 'desktop-setup-help-resolved',
  hronaut_agent_skill: 'agent-skill',
  homepage_goose_setup: 'homepage-goose-setup',
  homepage_grok_build_setup: 'homepage-grok-build-setup',
  homepage_latest_release: 'homepage-latest-release',
  homepage_qwen_code_setup: 'homepage-qwen-code-setup',
  homepage_windsurf_setup: 'homepage-windsurf-setup',
  mcp_tool_catalog: 'mcp-tool-catalog-download',
  opencode_browser_choice: 'reddit-opencode',
  opencode_quickstart: 'linkedin-opencode',
  website_share: 'website-share'
} as const

const CAMPAIGNS = Object.values(CAMPAIGN_BY_UTM)

type Campaign = typeof CAMPAIGNS[number]

function isCampaign(value: string | null): value is Campaign {
  return value !== null && CAMPAIGNS.includes(value as Campaign)
}

export function campaignFromSearch(search: string): Campaign | null {
  const parameters = new URLSearchParams(search)
  const direct = parameters.get('campaign')
  if (isCampaign(direct)) return direct

  const utmCampaign = parameters.get('utm_campaign')
  return utmCampaign && Object.hasOwn(CAMPAIGN_BY_UTM, utmCampaign)
    ? CAMPAIGN_BY_UTM[utmCampaign as keyof typeof CAMPAIGN_BY_UTM]
    : null
}

export function attributedInternalHref(
  href: string,
  origin: string,
  campaign: Campaign
): string | null {
  const url = new URL(href, origin)
  if (url.origin !== origin) return null
  if (url.pathname !== '/download' && !url.pathname.startsWith('/releases/')) return null

  url.searchParams.set('campaign', campaign)
  return `${url.pathname}${url.search}${url.hash}`
}

export function preserveCampaignInDownloadLinks(
  root: ParentNode = document,
  location: Pick<Location, 'origin' | 'search'> = window.location
): void {
  const campaign = campaignFromSearch(location.search)
  if (!campaign) return

  root.querySelectorAll<HTMLAnchorElement>('a[href]').forEach((anchor) => {
    const attributed = attributedInternalHref(anchor.href, location.origin, campaign)
    if (attributed) anchor.href = attributed
  })
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  preserveCampaignInDownloadLinks()
}
